module.exports = __webpack_public_path__ + "assets/images/premium-features/holiday-pay-89a4d9.png";